import InputBlock from './InputBlock';
import { InputBlockProps, InputBlockValueProps } from './types';

export type { InputBlockProps, InputBlockValueProps };
export default InputBlock;
